/*=========================================================================================
  File Name: moduleAuthMutations.js
  Description: Auth Module Mutations
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import axios from '../../http/axios/index.js'

/* eslint-disable */ 
export default {
  SET_BEARER (state, token) {
    axios.defaults.headers.common['Authorization'] = `Bearer ${token}`
  },
  SET_ACCESS_TOKEN (state, accessToken) {
    axios.defaults.headers.common['access_token'] =  accessToken;
  },
  SET_REFRESH_TOKEN (state, refreshToken) {
    axios.defaults.headers.common['Refresh'] =  `${refreshToken}`;
  }
}
